import store from '../../store/index'
import { userAtLeastIs, LEVEL_ADMIN } from '../../plugins/checkPermission'

export default (to, from, next) => {
    const requiresAdmin = to.matched.some((r) => r.meta.requiresAdmin)

    if (requiresAdmin)
        if (!store.state.user.profile) return next('/')
        else if (!userAtLeastIs(store.state.user.profile.level, LEVEL_ADMIN))
            return next('/')

    next()
}
